import React from "react"
import * as styles from "./styles.module.scss"

export const Container = ({children}) => (
  <div className={styles.Container}>{ children }</div>
)

export const TitleConatiner = ({children}) => (
  <div className={styles.TitleConatiner}>{ children }</div>
)

export const TitleText = ({ children }) => (
  <p className={ styles.TitleText }>{ children }</p>
)

export const SubTitle = (props) => (
  <h2 className={ styles.SubTitle }>
    <span className={ styles.SubTitle_Span }>
      <img className={ styles.SubTitle_Image } src={ props.image } alt={ props.alt }/>
    </span>
    { props.children }
  </h2>
)

export const Contents = ({ children }) => (
  <div className={styles.Contents}>{ children }</div>
)

export const FlexContainer= ({ children }) => (
  <div className={styles.FlexContainer}>{ children }</div>
)


export const ImageContainer = ({ children }) => (
  <div className={styles.ImageContainer}>{ children }</div>
)

export const ImageContainerImage = (props) => (
  <img className={ styles.ImageContainer_Image } src={ props.image } alt={ props.alt }/>
)

export const ImageContainerTitle= ({ children }) => (
  <h3 className={styles.ImageContainer_Title}>{ children }</h3>
)

export const SymptomsLayout = Container
SymptomsLayout.TitleConatiner = TitleConatiner
SymptomsLayout.TitleText = TitleText
SymptomsLayout.SubTitle = SubTitle
SymptomsLayout.Contents = Contents
SymptomsLayout.FlexContainer = FlexContainer
SymptomsLayout.ImageContainer = ImageContainer
SymptomsLayout.ImageContainerImage = ImageContainerImage
SymptomsLayout.ImageContainerTitle = ImageContainerTitle